export const sendAnalyticsEvent = (eventName: string, eventData?: Record<string, unknown>): void => {
  if (typeof window.MASendEvent !== 'function') {
    return;
  }

  window.MASendEvent(eventName, eventData);
};
